document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".ourJourney").forEach(function (section) {
    const glideEl = section.querySelector(".ourJourney__glide");
    const navContainer = section.querySelector(".ourJourney__nav");

    if (!glideEl || !navContainer) return;

    const rawSlides = section.querySelectorAll(".glide__slide:not(.glide__slide--clone)");

    if (rawSlides.length === 0) return;

    // Build label bullets from each slide's data-label attribute
    rawSlides.forEach(function (slide, index) {
      const label = slide.dataset.label || "";

      const btn = document.createElement("button");
      btn.classList.add("ourJourney__bullet");
      btn.setAttribute("data-glide-dir", "=" + index);
      btn.setAttribute("type", "button");
      btn.setAttribute("aria-label", "Go to slide " + (index + 1) + (label ? ": " + label : ""));

      const dot = document.createElement("span");
      dot.classList.add("ourJourney__bullet-dot");
      btn.appendChild(dot);

      if (label) {
        const labelEl = document.createElement("span");
        labelEl.classList.add("ourJourney__bullet-label");
        labelEl.textContent = label;
        btn.appendChild(labelEl);
      }

      navContainer.appendChild(btn);
    });

    const bullets = navContainer.querySelectorAll(".ourJourney__bullet");

    function updateActiveBullet(index) {
      bullets.forEach(function (b, i) {
        b.classList.toggle("is-active", i === index);
      });
    }

    if (rawSlides.length > 1) {
      const glide = new Glide(glideEl, {
        type: "slider",
        perView: 1,
        gap: 0,
        animationDuration: 600,
        animationTimingFunc: "ease-in-out",
        rewind: true,
      });

      glide.on("mount.after", function () {
        updateActiveBullet(glide.index);
      });

      glide.on("run", function () {
        updateActiveBullet(glide.index);
      });

      glide.mount();

      bullets.forEach(function (bullet) {
        bullet.addEventListener("click", function () {
          glide.go(bullet.getAttribute("data-glide-dir"));
        });
        bullet.addEventListener("keydown", function (event) {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            glide.go(bullet.getAttribute("data-glide-dir"));
          }
        });
      });
    } else {
      // Single slide — just mark first bullet active, no slider needed
      updateActiveBullet(0);
    }
  });
});
